if (!customElements.get('header-home')) {
  customElements.define(
    'header-home',
    class HeaderHome extends HTMLElement {
      constructor() {
        super();
        this.threshold = parseInt(this.dataset.scrollThreshold, 10) || 40;
        this.drawer = this.querySelector('.header-home__drawer');
        this.overlay = this.querySelector('.header-home__overlay');
        this.openButton = this.querySelector('[data-open-drawer]');
        this.closeButtons = this.querySelectorAll('[data-close-drawer]');

        this.onScroll = this.onScroll.bind(this);
        this.openDrawer = this.openDrawer.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        if (!this.drawer || !this.openButton) return;

        this.openButton.addEventListener('click', this.openDrawer);
        this.closeButtons.forEach((button) => button.addEventListener('click', this.closeDrawer));
        window.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('keydown', this.onKeydown);
        document.body.classList.remove('header-home-lock');
      }

      onScroll() {
        this.classList.toggle('header-home--scrolled', window.scrollY > this.threshold);
      }

      openDrawer(event) {
        event.preventDefault();
        this.classList.add('header-home--drawer-open');
        this.openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('header-home-lock');
        this.drawer.focus();
      }

      closeDrawer() {
        this.classList.remove('header-home--drawer-open');
        this.openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('header-home-lock');
        this.openButton.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('header-home--drawer-open')) {
          this.closeDrawer();
        }
      }
    }
  );
}
